export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200 text-foreground-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <a href="#hero" className="font-heading text-xl text-primary-500 whitespace-nowrap cursor-pointer">UU漫画</a>
            <p className="text-xs text-foreground-600 mt-3 leading-relaxed">
              UU漫画是专注韩漫推荐、日漫大全与国漫排行榜的免费漫画大全平台，
              每日更新热门漫画类型，帮你快速找到好看的漫画。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#updates" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">更新动态</a>
              <a href="#carousel" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">焦点专题</a>
              <a href="#ranking" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门榜单</a>
              <a href="#cards" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门推荐</a>
              <a href="#index" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">类型索引</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">热门漫画类型</h4>
            <div className="space-y-2">
              <a href="#cards" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">韩漫推荐</a>
              <a href="#cards" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">日漫大全</a>
              <a href="#cards" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">国漫排行榜</a>
              <a href="#topics" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门话题</a>
              <a href="#comments" className="block text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">读者热评</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              感谢以下合作伙伴对UU漫画的支持。
              合作事宜请联系 business@uumanhua.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} UU漫画 - 韩漫推荐 · 日漫大全 · 国漫排行榜 · 免费漫画大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">常见问答</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}